var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabMenu',{attrs:{"bgColor":true,"items":_vm.menu,"image":_vm.logo,"baseTo":'/maternidade/'}})}
var staticRenderFns = []

export { render, staticRenderFns }